export const changePermission = (state = [], action) => {
  switch (action.type) {
    case "add":
      return action.permissions;
    default:
      return state;
  }
};
